module.exports = __webpack_public_path__ + "static/media/search-villa.8ab1895b.svg";